import React, { useState } from 'react'
import { useNotify } from 'react-admin'
import { MjmlToJson } from 'easy-email-extensions'

import { Uploader } from '../utils'
import { Dropdown } from './Dropdown'

const importOptions = ['Import from JSON', 'Import from MJML']

const onImportJSON = async ({ restart, showError }) => {
  const uploader = new Uploader(() => Promise.resolve(''), {
    accept: 'application/json',
    limit: 1,
  })

  try {
    const [file] = await uploader.chooseFile()
    const reader = new FileReader()

    const emailTemplate = await new Promise((resolve, reject) => {
      reader.onload = function (evt) {
        if (!evt.target) {
          reject(new Error('File load failed.'))
          return
        }
        try {
          const template = JSON.parse(evt.target.result)
          resolve(template)
        } catch (error) {
          reject(new Error('Invalid JSON format.'))
        }
      }
      reader.readAsText(file)
    })

    restart({
      subject: emailTemplate.subject,
      content: emailTemplate.content,
      subTitle: emailTemplate.subTitle,
    })
  } catch (error) {
    showError(error.message)
  }
}

const onImportMJML = async ({ restart, showError }) => {
  const uploader = new Uploader(() => Promise.resolve(''), {
    accept: 'text/mjml',
    limit: 1,
  })

  try {
    const [file] = await uploader.chooseFile()
    const reader = new FileReader()

    const pageData = await new Promise((resolve, reject) => {
      reader.onload = function (evt) {
        if (!evt.target) {
          reject(new Error('File load failed.'))
          return
        }
        try {
          const pageData = MjmlToJson(evt.target.result)
          resolve([file.name, pageData])
        } catch (error) {
          reject(new Error('Invalid MJML format.'))
        }
      }
      reader.readAsText(file)
    })

    restart({
      subject: pageData[0],
      content: pageData[1],
      subTitle: '',
    })
  } catch (error) {
    showError(error.message)
  }
}

export const ImportTemplateDropdown = ({ restart }) => {
  const [errorMessage, setErrorMessage] = useState('')

  const notify = useNotify()

  const handleShowError = (message) => {
    setErrorMessage(message)
  }

  if (errorMessage) {
    notify(errorMessage, { type: 'error' })
  }

  const handleImport = (index) => {
    switch (index) {
      case 0:
        onImportJSON({ restart, showError: handleShowError })
        break
      case 1:
        onImportMJML({ restart, showError: handleShowError })
        break
      default:
        break
    }
  }

  return (
    <Dropdown
      options={importOptions}
      onOptionSelect={handleImport}
      buttonLabel="Import Template"
    />
  )
}
